/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useLayoutEffect, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

//*************** Libreria para realizar pdfs************************************* */
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// ------------------ COMPONENTES DE BASE--------------------------

// ------------------- CONSULTAS A LA API---------------------------
import { getEvaluacion } from "../../../API/RRHH/Evaluacion/EvaluacionPersonalRequets";
import { getFirmaPersonal } from "../../../API/Firmas/FirmasRequests"

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import { logoPPFBase64 } from './Imgs'
import { calificaciones, competencias, concienciaCompromiso, tiempoEntrega, resumen } from './Data'
import { formatFecha } from "../../../Base/Services/FechasService";

// pdfMake.vfs = pdfFonts.pdfMake.vfs;

const EvaluacionPersonalReporte = () => {
  const { IdEvaluacion } = useParams();
  const [informacion, setInformacion] = useState(null);
  const [idEvaluacion, setIdEvaluacion] = useState(0);
  const [responsabilidades, setResponsabilidades] = useState([]);
  const [objetivos, setObjetivos] = useState([])
  const [indicadores, setIndicadores] = useState([]);
  const [Mejoramiento, setMejoramiento] = useState([]);
  const [innovaciones, setInnovaciones] = useState([]);
  const [metas, setMetas] = useState([]);
  const [cursos, setCursos] = useState([]);
  const [Competencias, setCompetencias] = useState([]);
  const [ConcienciaCompromiso, setConcienciaCompromiso] = useState([]);
  const [TiemposEntrega, setTiemposEntrega] = useState([]);
  const [Resumen, setResumen] = useState([]);

  const obtenerInformacion = async () => {
    const tempoInformacion = await getEvaluacion(IdEvaluacion);

    
    if (tempoInformacion.length > 0) {
      
      let d = tempoInformacion[0]
      const seccionesExcluidas = ['14', '16', '23', '32', '34', '69', '71', '73', '75'];
      const seccionExcluida = seccionesExcluidas.includes(d.idseccion);
   
        setInformacion(d)
        let firmaEvaluador = null
        let firmaGerentePlanta = null
        let firmaRRHH = null
        let imgBlanco = await getFirmaPersonal('111')

        if(d.permiso1 === true){
            firmaEvaluador = await getFirmaPersonal(d?.idUserEvaluador)
        }
        if(d.permiso2 === true){
            firmaRRHH = await getFirmaPersonal("03766")
        }
        // if(d.permiso3 === true){
        //     firmaGerentePlanta = await getFirmaPersonal('06580')
        // }

        firmaGerentePlanta = await getFirmaPersonal('06580')

        // RESPONSABILIDADES
        const r = d.seleccion.filter(e => e.IdPregunta === null);
        setResponsabilidades(r);
        // COMPETENCIAS
        const compe = competencias.map(e => {
            return {
                ...e,
                value: d.seleccion.filter(i => i.IdPregunta === e.id)[0]?.value,
                Comentario: d.seleccion.filter(i => i.IdPregunta === e.id)[0]?.Comentario
            }
        })
        setCompetencias(compe);

        // CONCIENCIA Y COMPROMISO
        const conc = concienciaCompromiso.map(e => {
            return {
                ...e,
                value: d.seleccion.filter(i => i.IdPregunta === e.id)[0]?.value,
                Comentario: d.seleccion.filter(i => i.IdPregunta === e.id)[0]?.Comentario
            }
        })
        setConcienciaCompromiso(conc);

        // CONCIENCIA Y COMPROMISO
        const tiempos = tiempoEntrega.map(e => {
            return {
                ...e,
                value: d.seleccion.filter(i => i.IdPregunta === e.id)[0]?.value,
                Comentario: d.seleccion.filter(i => i.IdPregunta === e.id)[0]?.Comentario
            }
        })
        setTiemposEntrega(tiempos);

        // RESUMEN GENERAL
        const resu = resumen.map(e => {
            return {
                ...e,
                value: d.seleccion.filter(i => i.IdPregunta === e.id)[0]?.value,
                Comentario: d.seleccion.filter(i => i.IdPregunta === e.id)[0]?.Comentario
            }
        })
        setResumen(resu);

        // OBJETVOS
        const o = d.list.filter(e => e.Tipo === 5);
        setObjetivos(o);

        // INDICADORES
        const i = d.list.filter(e => e.Tipo === 1);
        setIndicadores(i);

        // MEJORAMIENTO
        const mj = d.list.filter(e => e.Tipo === 3);
        setMejoramiento(mj);

        // INNOVACIONES
        const ino = d.list.filter(e => e.Tipo === 2);
        setInnovaciones(ino);

        // METAS
        const met = d.list.filter(e => e.Tipo === 4);
        setMetas(met);

        // CURSOS
        const cur = d.list.filter(e => e.Tipo === 6);
        setCursos(cur);

        generarPDF(tempoInformacion[0], r, o, i, compe, conc, tiempos, mj, ino, met, cur, resu, firmaEvaluador, firmaRRHH, firmaGerentePlanta, imgBlanco, seccionExcluida);
    } 
  };

  useEffect(() => {
    if (IdEvaluacion) {
      obtenerInformacion(IdEvaluacion);
      setIdEvaluacion(IdEvaluacion);
    }
  }, [IdEvaluacion]);


  function capitalizeWords(str) {
    return str
      .toLowerCase() 
      .split(' ') 
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) 
      .join(' ');
  }



  const generarPDF = async (data, r, o, i, c, conc, tiempos, mj, ino, met, cur, resu, firmaEvaluador, firmaRRHH, firmaGerentePlanta, imgBlanco, seccionesExcluidas) => {

    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "portrait",
      pageMargins: [40, 105, 40, 105],

      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            columns: [
              {
                image: logoPPFBase64.logo,
                // image: "data:image/png;base64," + logoPPF,
                width: 200,
                margin: [4, 10, -10, -10],
              },
            ],
          },
          {
            table: {
              widths: ["*", "*", 80, 80],
              body: [
                [
                  {
                    text: "",
                    border: [false, true, false, false],
                    rowSpan: 3,
                  },
                  {
                    text: "",
                    border: [false, true, false, false],
                    rowSpan: 3,
                  },
                  {
                    image: logoPPFBase64.OEKO,
                    width: 80,
                    margin: [5, 2, -10, -10],
                    border: [false, true, false, false],
                    rowSpan: 3,
                  },
                  {
                    image: logoPPFBase64.natific,
                    width: 80,
                    margin: [5, 2, -10, -10],
                    border: [false, true, false, false],
                    rowSpan: 3,
                  },
                ],
                [{}, {}, {}, {}],
                [{}, {}, {}, {}],
              ],
            },
            layout: {
              hLineWidth: function (i, node) {
                return i === 0 ? 0.5 : 0;
              },
              hLineColor: function (i, node) {
                return i === 0 ? "#A0A0A0" : "transparent";
              },
            },
            margin: [190, -45, 30, 150],
            width: "auto",
          },
        ];
      },

      footer: (currentPage, pageCount) => {
      return {
        table: {
          widths: ["*"],
          body: [
              [
                  {
                      text: `${currentPage} / ${pageCount}`,
                      border: [false, false, false, false],
                      style: "infoFooter2",
                  },
              ],
              [
                  {
                  image: logoPPFBase64.foot,
                  width: 530,
                  margin: [35, 0, -50, -30],
                  border: [false, false, false, false] 
                  }
              ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0;
          },
          vLineWidth: function (i, node) {
            return i === 1 || i === 2 ? 0.5 : 0;
          },
          vLineColor: function (i, node) {
            return i === 1 || i === 2 ? "#A0A0A0" : "transparent";
          },
        },
        margin: [0, 10, 0, 0],
      }
      },

      content: [
        //------------------------------------------------------TITULO----------------------------------------------------
        {
          text: "Evaluación de desempeño laboral",
          style: "tituloP",
        },

        //------------------------------------------------------DATOS GENERALES----------------------------------------------------
        {
          table: {
            widths: [70, "*", 85, "*"],
            body: [
              [
                {
                  text: "Datos Generales",
                  colSpan: 4,
                  alignment: "center",
                  style: "tituloT",
                  fillColor: "#C1C9CB",
                  border: [true, true, true, true],
                },
                {},
                {},
                {},
              ],
              [
                {
                  text: "Nombre:",
                  style: "infoTitulos",
                  border: [true, false, false, false],
                },
                {
                  text: capitalizeWords(`${data?.NombreEmpleado}`),
                  style: "infoGeneral",
                  border: [false, false, true, false],
                },
                {
                  text: "Código:",
                  style: "infoTitulos",
                  border: [false, false, false, false],
                },
                {
                  text: `${data?.idpersonal}`,
                  style: "infoGeneral",
                  border: [false, false, true, false],
                },
              ],
              [
                {
                  text: "Sección:",
                  style: "infoTitulos",
                  border: [true, false, false, false],
                },
                {
                  text: capitalizeWords(`${data?.seccion}`),
                  style: "infoGeneral",
                  border: [false, false, true, false],
                },
                {
                  text: "Posición:",
                  style: "infoTitulos",
                  border: [false, false, false, false],
                },
                {
                  text: capitalizeWords(`${data?.posicion}`),
                  style: "infoGeneral",
                  border: [false, false, true, false],
                },
              ],
              [
                {
                  text: "Escolaridad:",
                  style: "infoTitulos",
                  border: [true, false, false, false],
                },
                {
                  text: capitalizeWords(`${data?.escolaridad}`),
                  style: "infoGeneral",
                  border: [false, false, true, false],
                },
                {
                  text: "Supervisor:",
                  style: "infoTitulos",
                  border: [false, false, false, false],
                },
                {
                  text: capitalizeWords(`${data?.evaluador}`),
                  style: "infoGeneral",
                  border: [false, false, true, false],
                },
              ],
              [
                {
                  text: "Fecha Ingreso:",
                  style: "infoTitulos",
                  border: [true, false, false, true],
                },
                {
                  text: formatFecha(`${data?.FechaIngreso}`),
                  style: "infoGeneral",
                  border: [false, false, true, true],
                },
                {
                  text: "Fecha Evaluación:",
                  style: "infoTitulos",
                  border: [false, false, false, true],
                },
                {
                  text: formatFecha(`${data?.Fecha}`),
                  style: "infoGeneral",
                  border: [false, false, true, true],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0.1; // Líneas horizontales delgadas
            },
            vLineWidth: function (i, node) {
              return 0.1; // Líneas verticales delgadas
            },
            hLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas horizontales
            },
            vLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas verticales
            },
          },
          margin: [0, 17, 0, 0],
        },

        //------------------------------------------------------OBJETIVOS DE DESEMPENO----------------------------------------------------
        {
          table: {
            widths: ["*"],
            body: [
              [
                {
                  text: "Objetivos de desempeño",
                  alignment: "center",
                  style: "tituloT",
                  fillColor: "#C1C9CB",
                  border: [true, true, true, true],
                },
              ],
              [
                {
                  text: "Responsabilidades Principales",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
              ],
              ...r.map((responsabilidad) => [
                {
                  text: `• ${responsabilidad.Pregunta}`,
                  style: "infoGeneral",
                  border: [true, false, true, false],
                  margin: [8, 0, 0, 0],
                },
              ]),
              [
                {
                  text: "Objetivos de desempeño",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
              ],
              ...o.map((obj) => [
                {
                  text: `• ${obj.valor}`,
                  style: "infoGeneral",
                  border: [true, false, true, false],
                  margin: [8, 0, 0, 0],
                },
              ]),
              [
                {
                  text: "Indicadores de Medición de Asignación",
                  fillColor: "#EAF1F3",
                  style: "infoTitulos",
                  border: [true, true, true, true],
                },
              ],
              ...i.map((ind) => [
                {
                  text: `• ${ind.valor}`,
                  style: "infoGeneral",
                  border: [true, false, true, false],
                  margin: [8, 0, 0, 0],
                },
              ]),
              [
                {
                  text: "", // Fila vacía para el borde general
                  border: [false, true, false, false],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0.1; // Líneas horizontales delgadas
            },
            vLineWidth: function (i, node) {
              return 0.1; // Líneas verticales delgadas
            },
            hLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas horizontales
            },
            vLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas verticales
            },
          },
          margin: [0, 17, 0, 0],
        },

        //------------------------------------------------------EVALUACION DE DESEMPENO----------------------------------------------------
        {
          table: {
            widths: [330, 60, "*"],
            body: [
              [
                {
                  text: "Evaluacion de desempeño",
                  alignment: "center",
                  style: "tituloT",
                  fillColor: "#C1C9CB",
                  border: [true, true, true, true],
                  colSpan: 3,
                },
                {},
                {},
              ],
              [
                {
                  text: "Responsabilidades Principales",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, false, false, true],
                },
                {
                  text: "Calificación",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, false, true, true],
                },
                {
                  text: "Comentarios",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [false, false, true, true],
                },
              ],

              ...r.map((responsabilidad) => [
                {
                  text: `${responsabilidad.Pregunta}`,
                  style: "infoGeneral",
                  border: [true, false, true, true],
                  margin: [8, 0, 0, 0],
                },
                {
                  text: `${
                    calificaciones.filter(
                      (e) => e.id === responsabilidad.value
                    )[0]?.name
                  }`,
                  style: "infoGeneral",
                  border: [false, false, true, true],
                  margin: [8, 0, 0, 0],
                },
                {
                  text: `${responsabilidad.Comentario || ""}`,
                  style: "infoGeneral",
                  border: [false, false, true, true],
                  margin: [8, 0, 0, 0],
                },
              ]),
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0.1; // Líneas horizontales delgadas
            },
            vLineWidth: function (i, node) {
              return 0.1; // Líneas verticales delgadas
            },
            hLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas horizontales
            },
            vLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas verticales
            },
          },
          margin: [0, 12, 0, 0],
        },

        //------------------------------------------------------COMPETENCIAS GLOBALES----------------------------------------------------
        {
          table: {
            widths: [250, 60, "*"],
            body: [
              [
                {
                  text: "Competencias Globales",
                  alignment: "center",
                  style: "tituloT",
                  fillColor: "#C1C9CB",
                  border: [true, true, true, true],
                  colSpan: 3,
                },
                {},
                {},
              ],
              [
                {
                  text: "Competencias",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
                {
                  text: "Calificación",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
                {
                  text: "Comentarios",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
              ],

              ...c.map((comp) => [
                {
                  text: `${comp.name}`,
                  style: "infoGeneral",
                  border: [true, false, true, true],
                  margin: [8, 0, 0, 0],
                },
                {
                  text: `${
                    calificaciones.filter((e) => e.id === comp.value)[0]?.name
                  }`,
                  style: "infoGeneral",
                  border: [true, false, true, true],
                  margin: [8, 0, 0, 0],
                },
                {
                  text: `${comp.Comentario || ""}`,
                  style: "infoGeneral",
                  border: [true, false, true, true],
                  margin: [8, 0, 0, 0],
                },
              ]),
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0.1; // Líneas horizontales delgadas
            },
            vLineWidth: function (i, node) {
              return 0.1; // Líneas verticales delgadas
            },
            hLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas horizontales
            },
            vLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas verticales
            },
          },
          margin: [0, 17, 0, 0],
        },

        //------------------------------------------------------NIVEL DE CONCIENCIA Y COMPROMISO----------------------------------------------------
        {
          table: {
            widths: [250, 60, "*"],
            body: [
              [
                {
                  text: "Nivel de conciencia y compromiso",
                  alignment: "center",
                  style: "tituloT",
                  fillColor: "#C1C9CB",
                  border: [true, true, true, true],
                  colSpan: 3,
                },
                {},
                {},
              ],
              [
                {
                  text: "Competencias",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
                {
                  text: "Calificación",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
                {
                  text: "Comentarios",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
              ],

              ...conc.map((c) => [
                {
                  text: `${c.name}`,
                  style: "infoGeneral",
                  border: [true, true, true, true],
                  margin: [8, 0, 0, 0],
                },
                {
                  text: `${
                    calificaciones.filter((e) => e.id === c.value)[0]?.name
                  }`,
                  style: "infoGeneral",
                  border: [true, true, true, true],
                  margin: [8, 0, 0, 0],
                },
                {
                  text: `${c.Comentario || ""}`,
                  style: "infoGeneral",
                  border: [true, true, true, true],
                  margin: [8, 0, 0, 0],
                },
              ]),
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0.1; // Líneas horizontales delgadas
            },
            vLineWidth: function (i, node) {
              return 0.1; // Líneas verticales delgadas
            },
            hLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas horizontales
            },
            vLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas verticales
            },
          },
          margin: [0, 17, 0, 0],
        },

        //------------------------------------------------------CUMPLIMIENTO EN LOS TIEMPOS D ENTREGA----------------------------------------------------
        {
          table: {
            widths: [250, 60, "*"],
            body: [
              [
                {
                  text: "Cumplimiento en los tiempos de entrega",
                  alignment: "center",
                  style: "tituloT",
                  fillColor: "#C1C9CB",
                  border: [true, true, true, true],
                  colSpan: 3,
                },
                {},
                {},
              ],
              [
                {
                  text: "Competencia",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
                {
                  text: "Calificación",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
                {
                  text: "Comentarios",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
              ],

              ...tiempos.map((t) => [
                {
                  text: `${t.name}`,
                  style: "infoGeneral",
                  border: [true, true, true, true],
                  margin: [8, 0, 0, 0],
                },
                {
                  text: `${
                    calificaciones.filter((e) => e.id === t.value)[0]?.name
                  }`,
                  style: "infoGeneral",
                  border: [true, true, true, true],
                  margin: [8, 0, 0, 0],
                },
                {
                  text: `${t.Comentario || ""}`,
                  style: "infoGeneral",
                  border: [true, true, true, true],
                  margin: [8, 0, 0, 0],
                },
              ]),
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0.1; // Líneas horizontales delgadas
            },
            vLineWidth: function (i, node) {
              return 0.1; // Líneas verticales delgadas
            },
            hLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas horizontales
            },
            vLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas verticales
            },
          },
          margin: [0, 17, 0, 0],
        },

        //------------------------------------------------------MEJORAMIENTO CONTINUO----------------------------------------------------
        {
          table: {
            widths: ["*"],
            body: [
              [
                {
                  text: "Mejoramiento Continuo",
                  alignment: "center",
                  style: "tituloT",
                  fillColor: "#C1C9CB",
                  border: [true, true, true, true],
                },
              ],
              [
                {
                  text: "Mejoras Implementadas en el Departamento",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
              ],
              ...mj.map((mej) => [
                {
                  text: `• ${mej.valor}`,
                  style: "infoGeneral",
                  border: [true, true, true, false],
                  margin: [8, 0, 0, 0],
                },
              ]),
              [
                {
                  text: "Innovaciones introducidas en su area",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
              ],
              ...ino.map((inn) => [
                {
                  text: `• ${inn.valor}`,
                  style: "infoGeneral",
                  border: [true, true, true, false],
                  margin: [8, 0, 0, 0],
                },
              ]),
              [
                {
                  text: "Enumere la lista de metas o logros en el año anterior",
                  fillColor: "#EAF1F3",
                  style: "infoTitulos",
                  border: [true, true, true, true],
                },
              ],
              ...met.map((m) => [
                {
                  text: `• ${m.valor}`,
                  style: "infoGeneral",
                  border: [true, true, true, false],
                  margin: [8, 0, 0, 0],
                },
              ]),
              [
                {
                  text: "",
                  border: [false, true, false, false],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0.1; // Líneas horizontales delgadas
            },
            vLineWidth: function (i, node) {
              return 0.1; // Líneas verticales delgadas
            },
            hLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas horizontales
            },
            vLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas verticales
            },
          },
          margin: [0, 17, 0, 0],
        },

        //------------------------------------------------------PLAN DE DESARROLLO DE HABILIDADES----------------------------------------------------
        {
          table: {
            widths: ["*"],
            body: [
              [
                {
                  text: "Plan de desarrollo de habilidades",
                  alignment: "center",
                  style: "tituloT",
                  fillColor: "#C1C9CB",
                  border: [true, true, true, true],
                },
              ],
              [
                {
                  text: "Cursos o programas en los cuales participo",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
              ],
              ...cur.map((c) => [
                {
                  text: `•` + capitalizeWords(`${c.valor}`),
                  style: "infoGeneral",
                  border: [true, true, true, true],
                  margin: [8, 0, 0, 0],
                },
              ]),
              // [
              //     {
              //         text: '',
              //         border: [false, true, false, false],
              //     }
              // ]
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0.1; // Líneas horizontales delgadas
            },
            vLineWidth: function (i, node) {
              return 0.1; // Líneas verticales delgadas
            },
            hLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas horizontales
            },
            vLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas verticales
            },
          },
          margin: [0, 17, 0, 0],
        },

        //------------------------------------------------------RESUMEN GENERAL----------------------------------------------------
        {
          table: {
            widths: [250, 60, "*"],
            body: [
              [
                {
                  text: "Resumen general",
                  alignment: "center",
                  style: "tituloT",
                  fillColor: "#C1C9CB",
                  border: [true, true, true, true],
                  colSpan: 3,
                },
                {},
                {},
              ],
              [
                {
                  text: "Competencia",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
                {
                  text: "Calificación",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
                {
                  text: "Comentarios",
                  style: "infoTitulos",
                  fillColor: "#EAF1F3",
                  border: [true, true, true, true],
                },
              ],

              ...resu.map((res) => [
                {
                  text: `${res.name}`,
                  style: "infoGeneral",
                  border: [true, true, true, true],
                  margin: [8, 0, 0, 0],
                },
                {
                  text: `${
                    calificaciones.filter((e) => e.id === res.value)[0]?.name
                  }`,
                  style: "infoGeneral",
                  border: [true, true, true, true],
                  margin: [8, 0, 0, 0],
                },
                {
                  text: `${res.Comentario || ""}`,
                  style: "infoGeneral",
                  border: [true, true, true, true],
                  margin: [8, 0, 0, 0],
                },
              ]),
              [
                {
                  text: `Calificación Promedio`,
                  style: "infoGeneral",
                  border: [true, true, true, true],
                  margin: [8, 0, 0, 0],
                },
                {
                  text: `${data?.Nota}%`,
                  style: "infoGeneral",
                  border: [true, true, true, true],
                  margin: [8, 0, 0, 0],
                },
                {
                  text: ``,
                  style: "infoGeneral",
                  border: [true, true, true, true],
                  margin: [8, 0, 0, 0],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0.1; // Líneas horizontales delgadas
            },
            vLineWidth: function (i, node) {
              return 0.1; // Líneas verticales delgadas
            },
            hLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas horizontales
            },
            vLineColor: function (i, node) {
              return "#74797A"; // Color gris para las líneas verticales
            },
          },
          margin: [0, 17, 0, 0],
        },

        //------------------------------------------------------COMENTARIO EMPLEADO----------------------------------------------------
        {
          table: {
            widths: ["*"],
            body: [
              [
                {
                  text: "Comentario Empleado",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: "  ",
                  border: [false, false, false, true],
                },
              ],
              [
                {
                  text: "  ",
                  border: [false, false, false, true],
                },
              ],
              [
                {
                  text: "  ",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0.1; // Líneas horizontales delgadas
            },
            vLineWidth: function (i, node) {
              return 0.1; // Líneas verticales delgadas
            },
          },
          margin: [0, 35, 0, 0],
        },

        // ------------------------------------------------------FIRMAS--------------------------------------------------------------------
        {
          margin: [80, 10, 0, 0],
          table: {
            widths: [150, 25, 150],
            body: [
              [
                { text: "   ", border: [false, false, false, true] },
                { text: "" },
                firmaEvaluador
                ? 
                  {
                    image: "data:image/png;base64," + firmaEvaluador,
                    width: data.idUserEvaluador === '06580' ? 80 : 150,
                    margin: data.idUserEvaluador === '06580' ? [40, 0, -50, 0] : [0, 0, -50, -30],
                    border: [false, false, false, true] 
                  }
                : 
                  {
                    image: "data:image/png;base64," + imgBlanco,
                    width: 300,
                    margin: [0, 0, -50, -30],
                    border: [false, false, false, true] 
                  },
              ],
              [
                {
                  style: "firmas",
                  text:`Colaborador` + "\n" + capitalizeWords(`${data?.NombreEmpleado}`),
                },
                { text: "" },
                {                     
                  style: "firmas",
                  text:`Jefe Inmediato` + "\n" + capitalizeWords(`${data?.evaluador}`), 
                },
              ],
            ],
          },
          layout: {
            defaultBorder: false,
          },
        },


        !seccionesExcluidas ? 

        {
          margin: [80, 10, 0, 0],
          table: {
            widths: [150, 25, 150],
            body: [
              //SEGUNDA FILA DE FIRMAS
              [
                firmaGerentePlanta ? 
                  {
                    image: "data:image/png;base64," + firmaGerentePlanta,
                    width: 80,
                    margin: [40, 0, -50, -30],
                    border: [false, false, false, true] 
                  }
                : 
                  {
                    image: "data:image/png;base64," + imgBlanco,
                    width: 300,
                    margin: [0, 0, -50, -30],
                    border: [false, false, false, true] 
                  },

                { text: "" },
                firmaRRHH ? 
                  {
                    image: "data:image/png;base64," + firmaRRHH,
                    width: 150,
                    margin: [0, 0, -50, -30],
                    border: [false, false, false, true] 
                  }
                : 
                  {
                    image: "data:image/png;base64," + imgBlanco,
                    width: 300,
                    margin: [0, 0, -50, -30],
                    border: [false, false, false, true] 
                  },
              ],
              [
                {
                  style: "firmas",
                  text:`Director de Planta \nLuis Abraham Erazo Lara`,
                },
                { text: "" },
                {                     
                  style: "firmas",
                  text:`Recursos Humanos \nMonica Scarleth Caballero Perdomo` 
                },
              ],
            ],
          },
          layout: {
            defaultBorder: false,
          },
        } 
        :
        {
          margin: [180, 10, 0, 0],
          table: {
            widths: [150],
            body: [
              //SEGUNDA FILA DE FIRMAS
              [
                firmaRRHH ? 
                  {
                    image: "data:image/png;base64," + firmaRRHH,
                    width: 150,
                    margin: [0, 0, -50, -30],
                    border: [false, false, false, true] 
                  }
                : 
                  {
                    image: "data:image/png;base64," + imgBlanco,
                    width: 300,
                    margin: [0, 0, -50, -30],
                    border: [false, false, false, true] 
                  },
              ],
              [
                {                     
                  style: "firmas",
                  text:`Recursos Humanos \nMonica Scarleth Caballero Perdomo` 
                },
              ],
            ],
          },
          layout: {
            defaultBorder: false,
          },
        },
        
      ],

      styles: {
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        infoFooter: {
          fontSize: 8,
          margin: [0, 0, 0, 0],
          color: "#A0A0A0",
        },
        infoFooter2: {
            fontSize: 10,
            margin: [0, 0, 50, 0],
            alignment: 'right'
        },
        tituloP: {
          fontSize: 13,
          bold: true,
          alignment: "justify",
          alignment: "center",
        },
        tituloT: {
          fontSize: 11,
          semibold: true,
          alignment: "justify",
          alignment: "center",
        },
        tituloT2: {
          fontSize: 11,
          semibold: true,
        },
        infoTitulos: {
          fontSize: 10,
          bold: true,
        },
        infoGeneral: {
          fontSize: 8.5,
        },
        firmas: {
          fontSize: 8,
          bold: true,
          alignment: "center",
          lineHeight: 1,
        },
      },
    };

    pdfMake.createPdf(docDefinition).open({}, window);
  };
};

export default EvaluacionPersonalReporte;
